import React from 'react'
import './Register.css'
import fintech from '../../Asists/img/fintechhub.svg'
import foto from '../../Asists/img/register.png'
import { HandPointer } from '../Icons/Icons'
export default function Register() {
    return (
        <div className='register'>
            <div className="foto">
                <img src={fintech} alt="" />
            </div>
            <div className="box">
                <h1 className="top">
                    to`xtang! juda muhim
                    {/* Sizga tezorada 71 203-88-00 <br /> raqamidan qo'ng'iroq qilamiza! */}
                </h1>
                <h1 className='h1_register'>
                    {/* Professional <span>dasturchi</span> bo'lishingiz <br />
                    uchun oxirgi qadam qoldi */}
                    Sizga tez orada <span> 71 203-88-00 </span>  raqamidan <br /> qo'ng'iroq qilamiz!
                </h1>
                <a href="https://t.me/fintechhubuz">
                    Kanalga a'zo bo'ling
                    <HandPointer className="fa-regular fa-hand-pointer" />
                </a>
                <p className="p_register">
                    <span>FintechHub</span> dasturlashga ilk qadam shu yerdan boshlanadi!
                </p>
            </div>
            <div className="bottom">
                <img src={foto} alt="" />
            </div>
        </div>
    )
}
